module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="timeline-section__divider"><div class="timeline-section__label">'+
((__t=( obj.label ))==null?'':__t)+
'</div></div>\n<div class=" js-timeline-container js-timeline"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/timeline-view/templates/timeline-collection.html
// module id = 414
// module chunks = 0